import React, { useState } from "react";
import { BlackAndWhite } from "../../../../../../../themes/Colors";
import FilterButtonSmall from "../filter-button-small/FilterButtonSmall";

const Filter = ({ filterName, setScreen }) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("PENDING");
  const [selectedHover, setSelectedHover] = useState(false);

  return (
    <div
      onClick={open ? null : () => setOpen(true)}
      style={{
        cursor: "pointer",
        height: 50,
        width: open ? 420 : 40,
        // borderStyle: "solid",
        // borderWidth: open ? 1 : 0,
        transition: "all 0.4s",
        marginRight: open ? 10 : 20,
        borderRadius: 100,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        backgroundColor: open ? BlackAndWhite.primary : BlackAndWhite.secondary,
      }}
    >
      {open ? null : (
        <div
          onClick={open ? null : () => setOpen(true)}
          style={{
            marginRight: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              borderStyle: "solid",
              backgroundColor: open
                ? BlackAndWhite.primary
                : BlackAndWhite.primary,
              color: open ? BlackAndWhite.secondary : BlackAndWhite.secondary,
              height: 35,
              width: 120,
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 80,
              borderWidth: open ? 0 : 0.5,
              marginLeft: open ? 7 : 0,
              fontSize: 14,
            }}
          >
            <div>{selected}</div>
          </div>
        </div>
      )}

      <div
        style={{
          flex: open ? 1 : 0,
          display: "flex",
          overflow: open ? null : "hidden",
        }}
      >
        <div
          style={{
            marginRight: 6,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: open ? 5 : null,
          }}
        >
          <div
            onMouseOver={() => setSelectedHover("pending")}
            onMouseOut={() => setSelectedHover(null)}
            onClick={() => {
              setSelected("PENDING");
              setOpen(false);
              setScreen("pending");
            }}
            style={{
              display: "flex",
              flexDirection: "column",
              borderStyle: "solid",
              backgroundColor: open
                ? selected === "PENDING"
                  ? BlackAndWhite.primary
                  : BlackAndWhite.secondary
                : null,
              color: open
                ? selected === "PENDING"
                  ? BlackAndWhite.secondary
                  : BlackAndWhite.primary
                : null,
              height: selectedHover === "pending" ? 40 : 35,
              width: selectedHover === "pending" ? 100 : 90,
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 80,
              borderWidth: open ? 0 : 0.5,
              marginLeft: open ? 7 : 0,
              fontSize: selectedHover === "pending" ? 14 : 12,
              transition: "all 0.3s",
              WebkitBoxShadow:
                selectedHover === "pending"
                  ? "0px 0px 5px 5px #FFFFFF90"
                  : "0px 0px 0px 0px #00000040",
            }}
          >
            <div>PENDING</div>
          </div>
        </div>
        <div
          style={{
            marginRight: 6,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            onMouseOver={() => setSelectedHover("IN PROGRESS")}
            onMouseOut={() => setSelectedHover(null)}
            onClick={() => {
              setSelected("IN PROGRESS");
              setOpen(false);
              setScreen("IN PROGRESS");
            }}
            style={{
              display: "flex",
              flexDirection: "column",
              borderStyle: "solid",
              backgroundColor: open
                ? selected === "IN PROGRESS"
                  ? BlackAndWhite.primary
                  : BlackAndWhite.secondary
                : null,
              color: open
                ? selected === "IN PROGRESS"
                  ? BlackAndWhite.secondary
                  : BlackAndWhite.primary
                : null,
              height: selectedHover === "IN PROGRESS" ? 40 : 35,
              width: selectedHover === "IN PROGRESS" ? 120 : 110,
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 80,
              borderWidth: open ? 0 : 0.5,
              marginLeft: open ? 7 : 0,
              fontSize: selectedHover === "IN PROGRESS" ? 14 : 12,
              transition: "all 0.3s",
              WebkitBoxShadow:
                selectedHover === "IN PROGRESS"
                  ? "0px 0px 5px 5px #FFFFFF90"
                  : "0px 0px 0px 0px #00000040",
            }}
          >
            <div>IN PROGRESS</div>
          </div>
        </div>
        <div
          style={{
            marginRight: 6,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            onMouseOver={() => setSelectedHover("complete")}
            onMouseOut={() => setSelectedHover(null)}
            onClick={() => {
              setSelected("COMPLETE");
              setOpen(false);
              setScreen("complete");
            }}
            style={{
              display: "flex",
              flexDirection: "column",
              borderStyle: "solid",
              backgroundColor: open
                ? selected === "COMPLETE"
                  ? BlackAndWhite.primary
                  : BlackAndWhite.secondary
                : null,
              color: open
                ? selected === "COMPLETE"
                  ? BlackAndWhite.secondary
                  : BlackAndWhite.primary
                : null,
              height: selectedHover === "complete" ? 40 : 35,
              width: selectedHover === "complete" ? 110 : 100,
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 80,
              borderWidth: open ? 0 : 0.5,
              marginLeft: open ? 7 : 0,
              fontSize: selectedHover === "complete" ? 14 : 12,
              transition: "all 0.3s",
              WebkitBoxShadow:
                selectedHover === "complete"
                  ? "0px 0px 5px 5px #FFFFFF90"
                  : "0px 0px 0px 0px #00000040",
            }}
          >
            <div>COMPLETE</div>
          </div>
        </div>
      </div>
      <FilterButtonSmall
        icon1={
          open
            ? require("../../../../../../../images/material-icons/setupAndMangeWhite.png")
            : require("../../../../../../../images/material-icons/setupAndMangeBlack.png")
        }
        icon2={
          open
            ? require("../../../../../../../images/material-icons/setupAndMangeWhite.png")
            : require("../../../../../../../images/material-icons/setupAndMangeBlack.png")
        }
        label={open ? "CLOSE" : filterName}
        iconHeight={20}
        iconWidth={20}
        fontSize={12}
        fontColor={open ? BlackAndWhite.secondary : BlackAndWhite.primary}
        fontColor1={open ? BlackAndWhite.secondary : BlackAndWhite.primary}
        onClick={() => setOpen(false)}
      />
      <div style={{ width: 10 }} />
    </div>
  );
};

export default Filter;
